import { Validators, FormGroup } from '@angular/forms';
import { DocumentType } from '../enum/document-type.enum';
import { ValidatorOnlyNumber } from './number.validator';

export function DocumentTypeValidator(
    controlDocumentType: string,
    controlDocumentNumber: string
): (formGroup: FormGroup) => void {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlDocumentType];
        const controlNumber = formGroup.controls[controlDocumentNumber];
        const documentType = control.value;

        switch (documentType) {
            case DocumentType.DNI:
                controlNumber.setValidators([
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(8),
                    ValidatorOnlyNumber,
                ]);

                break;
            case DocumentType.PASSPORT:
            case DocumentType.FOREIGN_CARD:
                controlNumber.setValidators([
                    Validators.required,
                    Validators.maxLength(12),
                ]);
                break;
            case DocumentType.PTP:
                controlNumber.setValidators([
                    Validators.required,
                ]);
                break;
            case DocumentType.RUC:
                controlNumber.setValidators([
                    Validators.required,
                    Validators.minLength(11),
                    Validators.maxLength(11),
                ]);
                break;
            default:
                break;
        }
    };
}
